import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Model } from "src/logic/model";

@Injectable()
/**взаимодействие с сервером */
export class ServerService {
  constructor(private http: HttpClient, private model: Model){}

  readonly hostUrl = 'http://localhost:8888/';
  readonly baseUrl = this.hostUrl + 'api/CodersPattern/';

  /**post запрос */
  public post(methodName: string, data: any, isFullUrl: boolean = false): Observable<any> {
    console.log('post '+  methodName,data);
    return this.http.post((isFullUrl ? '' : this.baseUrl) + methodName, data);
  }

}